const mobileProxy = {

  communication: function (data) {
    try {
      data = data === '' ? '{}' : data
      let obj = {
        name: data.name,
        body: data.body,
        callName: ''
      }
      // console.log('调用端内subClientMsg方法：' + handlerName + '|' + callbackId + '|' + callbackName + '|' + data)
      obj = typeof (obj) === 'object' ? JSON.stringify(obj) : obj
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      var isiOS = !!u.match(/(i[^;]+;( U;)? CPU.+Mac OS X)/);
      if (isiOS) {
        console.log(window.webkit.messageHandlers)
        // 假设方法名为： JSMessageName；postMessage里面可以传参数
        window.webkit.messageHandlers.JSMessageName.postMessage(obj)
      } else if (isAndroid) {
        window.Mobile.getUserToken(obj)
        // window.appAndroid.subClientMsg(obj)
      }
    } catch (e) {
      // alert('与端内交互失败,原因:' + funName + '接口报错')
      console.log('与端内交互失败,原因:接口报错')
    }
  }

}


export default mobileProxy


// WEBPACK FOOTER //
// ./src/common/mobileProxy.js